// extracted by mini-css-extract-plugin
export default {"active":"navbar_active__yhyRv","dropdown":"navbar_dropdown__MGV1R","hidden":"navbar_hidden__nkUyT"};